import Icon from "@chakra-ui/icon"
import { Flex, Grid, GridItem, Heading, Stack } from "@chakra-ui/layout"
import React, { useState } from "react"
import PensilRightIcon from "../../assets/pencil-right.svg"
import Slogan from "../../assets/slogan.svg"
import PensilLeftIcon from "../../assets/pencil-left.svg"
import BigPlayIcon from "../../assets/big-play-icon.svg"
import { Img } from "@chakra-ui/image"
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/modal"
import ReactPlayer from "react-player"
import { useDisclosure } from "@chakra-ui/hooks"

const content = [
    {
        img: "https://img.youtube.com/vi/xdKhsDKEOn0/mqdefault.jpg",
        video: "xdKhsDKEOn0",
        title: "Бојана Матић",
    },

    {
        img: "https://img.youtube.com/vi/HAuEa7VzJ7c/mqdefault.jpg",
        video: "HAuEa7VzJ7c",
        title: "Александар Старчевић",
    },
    {
        img: "https://img.youtube.com/vi/aEs_VyPnM0A/mqdefault.jpg",
        video: "aEs_VyPnM0A",
        title: "Бранко Суботић",
    },
    {
        img: "https://img.youtube.com/vi/v3BDzEK6uLQ/mqdefault.jpg",
        video: "v3BDzEK6uLQ",
        title: "Драгиша Миљковић",
    },
    {
        img: "https://img.youtube.com/vi/HC585RK15gg/mqdefault.jpg",
        video: "HC585RK15gg",
        title: "Ивана Ковачевић",
    },
    {
        img: "https://img.youtube.com/vi/mtGeaW2qmhM/mqdefault.jpg",
        video: "mtGeaW2qmhM",
        title: "Катарина Радосављевић",
    },
    {
        img: "https://img.youtube.com/vi/G3MFQyg2kAE/mqdefault.jpg",
        video: "G3MFQyg2kAE",
        title: "Љиљана Лазаревић",
    },
    {
        img: "https://img.youtube.com/vi/TFMepg7mtv8/mqdefault.jpg",
        video: "TFMepg7mtv8",
        title: "Александра Живковић",
    },
]

const EduBottomBanner = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [tempId, setTempId] = useState("0")
    return (
        <Stack spacing={["30px", "30px", "50px"]}>
            <Flex
                w="100%"
                h={["190px", "200px", "290px", "394px"]}
                bg="_blue"
                justify="center"
                align={["flex-end", "center"]}
                py={["10px", "10px", "10px", "52px"]}
                direction={["column", "row"]}
                gridGap="20px"
            >
                <Flex w="55%" mr={["auto", "0px"]} ml="30px" justify="center">
                    <Icon as={Slogan} w="100%" maxW="723px" h="100%" maxH="280px" />
                </Flex>

                <Flex w={["65%", "55%"]} justify="flex-end" maxW="1400px">
                    <Icon as={PensilRightIcon} width="100%" height="100%" maxW="1400px" />
                </Flex>
            </Flex>
            <Flex
                w="100%"
                bg="_red"
                h={["100px", "166px", "172px", "176px"]}
                justify={["flex-start", "center"]}
                align={["center"]}
                direction="column"
                pos="relative"
                pt="10px"
            >
                <Flex
                    justify="flex-start"
                    transform={[
                        "translate(0px, 24px)",
                        "translate(0px, 22px)",
                        "translate(0px, 34px)",
                        "translate(0px, 34px)",
                        "translate(0px, 54px)",
                    ]}
                    pos="absolute"
                    bottom="0"
                    left="0"
                >
                    <Icon
                        as={PensilLeftIcon}
                        w={["260px", "260px", "420px", "420px", "570px"]}
                        h="100%"
                    />
                </Flex>
                <Heading
                    fontSize={["24px", "32px", "38px", "48px"]}
                    fontWeight="900"
                    maxW={["700px", "700px", "700px"]}
                    textAlign="center"
                    color="#fff"
                    pb={[null, null, "25px"]}
                    pr={["10px", "40px", "40px", null]}
                    pl={["10px", "40px", "40px"]}
                    textTransform="uppercase"
                >
                    Људи који знање деле
                </Heading>
            </Flex>
            <Flex justify="center" align="center" py={["20px", "20px", "20px", "140px"]} w="100%">
                <Grid
                    gap={3}
                    gridTemplateColumns={[
                        "repeat(auto-fill,minmax(280px,1fr))",
                        "repeat(auto-fill,minmax(280px,1fr))",
                        "repeat(auto-fill,minmax(280px,1fr))",
                        "repeat(auto-fill,minmax(400px,1fr))",
                    ]}
                    gridTemplateRows="auto"
                    maxW="1800px"
                    px={["10px", "10px", "10px", "40px"]}
                    justifyItems="center"
                    w="100%"
                >
                    {content.map((slide, i) => {
                        return (
                            <GridItem
                                key={i}
                                w={["260px", "260px", "260px", "400px"]}
                                h={["128px", "128px", "128px", "200px"]}
                                cursor="pointer"
                                _hover={{
                                    border: "2px solid",
                                    borderColor: "#fff",
                                }}
                                onClick={() => {
                                    setTempId(i)
                                    onOpen()
                                }}
                                title={slide.title}
                            >
                                <Icon
                                    as={BigPlayIcon}
                                    w="59px"
                                    h="54px"
                                    pos="absolute"
                                    transform={[
                                        "translate(110px, 40px)",
                                        "translate(110px, 40px)",
                                        "translate(110px, 40px)",
                                        "translate(170px, 73px)",
                                    ]}
                                />

                                <Img
                                    src={slide.img}
                                    w="100%"
                                    h="100%"
                                    objectFit="cover"
                                    objectPosition="top"
                                />
                            </GridItem>
                        )
                    })}
                    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                        <ModalOverlay bg="rgba(23, 18, 10, 0.85)" />
                        <ModalContent>
                            <ModalCloseButton top="-10" bg="#fff" _hover={{ bg: "#fff" }} />
                            <ModalBody pt="56.25%">
                                {/* Video... */}
                                <ReactPlayer
                                    url={`https://youtu.be/${content[tempId].video}`}
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                    }}
                                    width="100%"
                                    height="100%"
                                    controls
                                    playing
                                    config={{
                                        youtube: {
                                            preload: true,
                                        },
                                    }}
                                />
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </Grid>
            </Flex>
        </Stack>
    )
}

export default EduBottomBanner
